export const dateFunctions = {
    checkDateOverlap: (obja, objb)=> {
        if (objb.start >= obja.start && objb.start <= obja.end) return true;
        if (objb.start <= obja.start && objb.end >= obja.start) return true;
        if (objb.start <= obja.start && objb.end >= obja.end) return true;
        if (obja.start == objb.start && obja.end == objb.end) return true;
        return false;
    }
}

